//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CodeDiff from 'vue-code-diff';
export default {
  components: {
    CodeDiff,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    show: {
      type: Boolean,
      default: false,
    },
    oldString: {
      type: String,
      default: '',
    },
    newString: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      codeDiffContainer: null,
      width: '60%',
    };
  },
  computed: {
    visible: {
      get() {
        return this.show;
      },
      set(value) {
        if (!value) {
          this.cancel();
        }
      },
    },
  },
  watch: {
    visible(value) {
      if (value) {
        this.$nextTick(() => {
          this.codeDiffContainer = document.querySelectorAll('.d2h-file-side-diff');
          for (let i = 0; i < this.codeDiffContainer.length; i++) {
            const element = this.codeDiffContainer[i];
            element.addEventListener('scroll', this.syncScrollTop);
          }
        });
      } else {
        for (let i = 0; i < this.codeDiffContainer.length; i++) {
          const element = this.codeDiffContainer[i];
          element.removeEventListener('scroll', this.syncScrollTop);
        }
        this.smallScreen();
      }
    },
  },
  methods: {
    cancel() {
      this.$emit('cancel');
    },
    syncScrollTop(e) {
      for (let i = 0; i < this.codeDiffContainer.length; i++) {
        const element = this.codeDiffContainer[i];
        element.scrollTop = e.target.scrollTop;
      }
    },
    fullScreen() {
      this.width = '100%';
      const heightCon = document.querySelector('.d2h-files-diff');
      heightCon.style.minHeight = 'calc(100vh - 78px)';
    },
    smallScreen() {
      this.width = '60%';
      const heightCon = document.querySelector('.d2h-files-diff');
      heightCon.style.minHeight = '80vh';
    },
  },
};
